import React from "react";
import "./Bookmarks.css";
import { useSelector } from "react-redux";
import "./Bookmarks.css"; // ✅ Your existing CSS
import BookmarkMentorsCard from "../../../src/components/Cards/BookmarkMentorsCard";
import TileBookmark from "../../components/Tile/TileBookmark";
const Bookmarks = () => {
  const bookmarkedMentors = useSelector(
    (state) => state.bookmark.bookmarkedMentors
  );

  const bookmarkedResources = useSelector(
    (state) => state.resourceBookmarks.bookmarkedResources
  );

  return (
    <>
      <div className="bookmarks">
        <div className="bookmark-section">
          <h2 className="favorite-resources">Favorite Resources</h2>
          <div className="mentor-bookmark-tiles">
            {bookmarkedResources.length === 0 ? (
              <p>No favorite resources yet.</p>
            ) : (
              bookmarkedResources.map((resource, index) => (
                <TileBookmark
                  key={resource.name || index}
                  name={resource.name}
                  title={resource.title} // fallback if Card expects `title`
                  description={resource.description}
                  thumbnail={resource.thumbnail}
                  url={resource.url}
                />
              ))
            )}
          </div>
        </div>
      </div>

      <div className="bookmarks">
        <div className="bookmark-section">
          <h2 className="favorite-mentors">Favorite Mentors</h2>
          <div className="mentor-bookmark-tiles">
            {bookmarkedMentors.length === 0 ? (
              <p>No favorite mentors yet.</p>
            ) : (
              bookmarkedMentors.map((mentor) => (
                <BookmarkMentorsCard
                  key={mentor._id?.$oid || mentor._id}
                  _id={mentor._id}
                  name={mentor.name}
                  title={mentor.title}
                  thumbnail={mentor.thumbnail}
                  mentorUrl={mentor.mentorUrl}
                />
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Bookmarks;
